/* global axios */
import ApiClient from './ApiClient';

class PainelAPI extends ApiClient {
  constructor() {
    super('dashboard', { accountScoped: true, apiVersion: 'v2' });
  }

  overview(params) {
    return axios.get(`${this.url}/overview`, { params });
  }

  pendingConversations() {
    return axios.get(`${this.url}/pending_conversations`);
  }

  heatmap(params) {
    return axios.get(`${this.url}/heatmap`, { params });
  }

  nps(params) {
    return axios.get(`${this.url}/nps`, { params });
  }

  get painelBaseUrl() {
    return `/api/v1/accounts/${this.accountIdFromRoute}/painel`;
  }

  // Appointments — unified CRUD
  fetchAppointments(params) {
    return axios.get(`${this.painelBaseUrl}/appointments`, { params });
  }

  fetchUpcomingAppointments() {
    return axios.get(`${this.painelBaseUrl}/appointments/upcoming`);
  }

  confirmAppointment(id, payload = {}) {
    return axios.post(
      `${this.painelBaseUrl}/appointments/${id}/confirm`,
      payload
    );
  }

  fetchAppointment(id) {
    return axios.get(`${this.painelBaseUrl}/appointments/${id}`);
  }

  createAppointment(payload) {
    return axios.post(`${this.painelBaseUrl}/appointments`, payload);
  }

  updateAppointment(id, payload) {
    return axios.patch(`${this.painelBaseUrl}/appointments/${id}`, payload);
  }

  deleteAppointment(id, payload = {}) {
    return axios.delete(`${this.painelBaseUrl}/appointments/${id}`, {
      data: payload,
    });
  }

  retrySync(id) {
    return axios.post(`${this.painelBaseUrl}/appointments/${id}/retry_sync`);
  }

  // OpenAPI spec
  fetchApiSpec(format = 'yaml') {
    return axios.get(`${this.painelBaseUrl}/api_spec`, {
      headers: {
        Accept: format === 'json' ? 'application/json' : 'application/yaml',
      },
      responseType: 'text',
    });
  }

  // Calendar
  calendarState() {
    return axios.get(`${this.painelBaseUrl}/calendar`);
  }

  listGoogleCalendars() {
    return axios.get(`${this.painelBaseUrl}/calendar/calendars`);
  }

  resyncCalendar() {
    return axios.post(`${this.painelBaseUrl}/calendar/resync`);
  }

  disconnectCalendar() {
    return axios.delete(`${this.painelBaseUrl}/calendar`);
  }

  fetchSettings() {
    return axios.get(`${this.painelBaseUrl}/setting`);
  }

  updateSettings(payload) {
    return axios.patch(`${this.painelBaseUrl}/setting`, payload);
  }

  fieldDefinitions() {
    return axios.get(`${this.painelBaseUrl}/field_definitions`);
  }

  createFieldDefinition(payload) {
    return axios.post(`${this.painelBaseUrl}/field_definitions`, {
      field_definition: payload,
    });
  }

  updateFieldDefinition(id, payload) {
    return axios.patch(`${this.painelBaseUrl}/field_definitions/${id}`, {
      field_definition: payload,
    });
  }

  deleteFieldDefinition(id) {
    return axios.delete(`${this.painelBaseUrl}/field_definitions/${id}`);
  }

  reorderFieldDefinitions(ids) {
    return axios.post(`${this.painelBaseUrl}/field_definitions/reorder`, {
      ids,
    });
  }

  fetchHumanAttentionRequests(params = {}) {
    return axios.get(`${this.painelBaseUrl}/human_attention_requests`, {
      params,
    });
  }

  lookupHumanAttention(phoneNumber) {
    return axios.get(`${this.painelBaseUrl}/human_attention_requests/lookup`, {
      params: { phone_number: phoneNumber },
    });
  }

  createHumanAttentionRequest(payload) {
    return axios.post(
      `${this.painelBaseUrl}/human_attention_requests`,
      payload
    );
  }

  attendHumanAttentionRequest(id) {
    return axios.post(
      `${this.painelBaseUrl}/human_attention_requests/${id}/attend`
    );
  }

  markReadByPhone(payload) {
    return axios.post(
      `/api/v1/accounts/${this.accountIdFromRoute}/conversations/mark_read_by_phone`,
      payload
    );
  }
}

export default new PainelAPI();
